import React from 'react'
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {Link} from "react-router-dom";

class ItemDashBoard extends React.Component {

    render() {
        const {title, description, path, icon} = this.props;
        return (
            <Grid item xs={4} style={{padding: '20px'}}>
                <Link to={path} variant="body2">
                    <Card style={{maxHeight: '220px', minHeight: '220px', height: '220px'}}>
                        <CardContent>
                            <Typography variant="h5" component="h2">
                                {title}
                            </Typography>

                            {icon}

                            <Typography color="textSecondary">
                                {description}
                            </Typography>
                        </CardContent>
                    </Card>
                </Link>
            </Grid>
        );
    }
}

export default ItemDashBoard